export default "__VITE_ASSET__21187aed__"